<template>
<div class='bodyer recharge index'>
    <div class='banner'>
        <img src='/static/image/recharge/banner.jpg'>
    </div>
    <div class='main'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-9'>
                    <div class='yi-title'>
                        新闻 ● 热门活动
                    </div>
                    <!--<div class='list-game row'>-->
                        <!--<div class='col-md-4' v-for='item in games' @click='toUrl("/recharge/redeem-game")'>-->
                            <!--<div class='game'>-->
                                <!--<div class='banner'>-->
                                    <!--<img :src='item.banner'>-->
                                <!--</div>-->
                                <!--<div class='name'>{{item.name}}</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <ul class="news">
                        <li v-for='item in news.list' @click='toNews(item)'>
                            {{item.title_sim}}
                            <span class='date'>{{item.created_at}}</span>
                        </li>
                    </ul>
                </div>
                <div class='col-md-3'>
                    <div class='yi-title'>
                        快捷入口
                    </div>
                    <div class='box-nav'>
                        <div class='link' @click='toUrl("/register")'>
                            <i class='icon iconfont icon-umidd17' style='color: #24C358'></i>
                            <span>账号注册</span>
                        </div>
                        <div class='link' @click='toUrl("/recharge")'>
                            <i class='icon iconfont icon-qietu08' style='color:#44D0B6'></i>
                            <span>游戏充值</span>
                        </div>
                        <div class='link' @click='openUrl("https://m2.unnda.cn:8080/#/download")'>
                            <i class='icon iconfont icon-jilu' style='color:#E655FD'></i>
                            <span>游戏下载</span>
                        </div>
                        <div class='link' @click='toUrl("/service")'>
                            <i class='icon iconfont icon-dianhua-copy-copy-copy-copy'
                               style='color: #008DD5'></i>
                            <span>客服</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import Common from '@/common/Common'
import Request from '@/common/Request'
import Storage from '@/common/Storage'
export default {
    data : function(){
        return {
            'games' : [
                {
                    'name' : 'M2神甲奇兵',
                    'banner' : '/static/image/game-banner-1.png',
                    'id' : 1
                },{
                    'name' : 'M2神甲奇兵',
                    'banner' : '/static/image/game-banner-2.png',
                    'id' : 2
                },{
                    'name' : 'M2神甲奇兵',
                    'banner' : '/static/image/game-banner-3.png',
                    'id' : 3
                },{
                    'name' : 'M2神甲奇兵',
                    'banner' : '/static/image/game-banner-4.png',
                    'id' : 4
                },{
                    'name' : 'M2神甲奇兵',
                    'banner' : '/static/image/game-banner-5.png',
                    'id' : 5
                },{
                    'name' : 'M2神甲奇兵',
                    'banner' : '/static/image/game-banner-6.png',
                    'id' : 6
                }
            ],
            'news' : {
                'list': false,
            }
        }
    },
    props : ['user'],
    methods : {
        'getNews' : function(){
            var url = Request.createApi('/app/news/list?where[position]=list&page=1&limit=5')
            Request.get(url, res => {
                this.news.list = res.list
            })
        },
        'toNews' : function(news){
            Storage.set('news', news)
            Common.toUrl('/news/item?id='+news.id)
        },
        openUrl:function(url){
            window.location.href=url
        },
        //打开链接
        toUrl : function(url){
            Common.toUrl(url)
        }
    },
    created : function(){
        window.scrollTo(0, 0)
        this.getNews()
    }
}
</script>
<style scoped>
    ul.news{
        list-style: none;
        padding-left: 0px;

    }
    ul.news li{
        cursor: pointer;
        padding: 10px 0px;
        position: relative;
        padding-left: 10px;
        border-bottom: #bcbcbc 1px dashed;
    }
    ul.news li:before{
        content: ' ';
        display: inline-block;
        width: 6px;
        height: 6px;
        position: absolute;
        left: 0px;
        top: 13px;
        border-radius: 50%;
        background-color: #ff9434;
    }
    ul.news li .type{
        color: #F33;
    }
    ul.news li .date{
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/news/List.vue